import Vue from 'vue'
import Router from 'vue-router'
import SiteView from '@/components/Site'
import HomeView from '@/components/Home'
import PLDetail from '@/components/PLDetail'
import Listing from '@/components/Listing'
import PullSheetView from '@/components/PullSheetView'
import PasswordReset from '@/components/PasswordReset'
import AboutPage from '@/components/AboutPage'
import ContactPage from '@/components/ContactPage'
import SubmitPropertyPage from '@/components/SubmitPropertyPage'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: SiteView,
      children: [
        {
          path: '',
          name: 'Site',
          component: HomeView
        },
        {
          path: 'location/:plno',
          component: PLDetail
        },
        {
          path: 'pullsheet/:token',
          component: PullSheetView
        },
        {
          path: 'browse',
          component: Listing
        },
        {
          path: 'browse/*',
          component: Listing
        },
        {
          path: 'passwordreset/:token',
          component: PasswordReset
        },
        {
          path: 'about',
          component: AboutPage
        },
        {
          path: 'contact',
          component: ContactPage
        },
        {
          path: 'submitproperty',
          component: SubmitPropertyPage
        }
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js